import { render, staticRenderFns } from "./AppointmentDefaultList.vue?vue&type=template&id=6e7631d7&lang=pug"
import script from "./AppointmentDefaultList.vue?vue&type=script&lang=js"
export * from "./AppointmentDefaultList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports